import { Kbd } from "@/components/ui/form";
import { Dialog, DialogBody, DialogContent } from "@/components/ui/overlay";

const mod = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform) ? "⌘" : "Ctrl";

const GROUPS: { title: string; rows: [string, string[]][] }[] = [
  {
    title: "Everywhere",
    rows: [
      ["Go to… (command palette)", [mod, "K"]],
      ["Show this list", ["?"]],
      ["Collapse / expand the sidebar", ["["]],
      ["Close a dialog or menu", ["Esc"]],
    ],
  },
  {
    title: "Reels board",
    rows: [
      ["New reel", ["N"]],
      ["Search", ["/"]],
    ],
  },
  {
    title: "Reel editor",
    rows: [
      ["Next / previous card", ["J", "K"]],
      ["Move the card up / down", ["Alt", "Shift", "↑ / ↓"]],
      ["Duplicate card", [mod, "D"]],
      ["Delete card (from the card list)", ["Del"]],
      ["Hear this card", ["P"]],
      ["Undo / redo", [mod, "Z", "/", mod, "Shift", "Z"]],
      ["Save now", [mod, "S"]],
      ["Build the reel", [mod, "Enter"]],
    ],
  },
];

export function ShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title="Keyboard shortcuts" description="Shortcuts don't fire while you're typing in a text box.">
        <DialogBody className="flex flex-col gap-5">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <h3 className="mb-1.5 text-2xs font-medium uppercase tracking-wide text-subtle">{g.title}</h3>
              <div className="divide-y divide-border rounded-md border border-border">
                {g.rows.map(([label, keys]) => (
                  <div key={label} className="flex items-center justify-between gap-4 px-3 py-2 text-sm">
                    <span>{label}</span>
                    <span className="flex items-center gap-1">
                      {keys.map((k, i) => (k === "/" ? <span key={i} className="text-subtle">/</span> : <Kbd key={i}>{k}</Kbd>))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
